var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "couponLog",
      on: {
        click: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      _c("div", { staticClass: "couponLogTitle" }, [
        _vm._v("优惠券"),
        _c("i", {
          staticClass: "el-icon-close fr pointer",
          on: { click: _vm.close },
        }),
      ]),
      _c(
        "div",
        { staticClass: "myTable" },
        [
          _c(
            "el-table",
            {
              staticStyle: { widht: "566px" },
              attrs: {
                data: _vm.list,
                "header-cell-style": { background: "#F3F3F3" },
                "max-height": "300px",
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "couponNo", label: "优惠券ID" },
              }),
              _c("el-table-column", {
                attrs: { prop: "couponName", label: "券名称" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "领取时间",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("parseTime")(
                                row.createTime,
                                "{y}-{m}-{d} {h}:{i}"
                              )
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }